export enum HistorySosStatusText {
	paid = 'Оплачено',
	cancelled = 'Отменен'
}

export enum HistorySosStatusColor {
	paid = '#24D321',
	cancelled = '#ED4141'
}
